import {NavigationTabsModuleEntityViewModel} from "./navigation-tabs-module.entity.view-model";
import {override} from 'mobx';
import {NAVIGATION_TABS} from "../../navigation-tabs-module.consts";
import {NavigationTabsModuleTabModel} from "../tabs/navigation-tabs-module.tab-model";
import {NavigationTabsModuleTerms} from "../../navigation-tabs-module.terms";
import {MatchesFilterTabModel} from "../tabs/matches-filter/matches-filter.tab-model";
import {NewMatchesFilterResultsTabModel} from "../tabs/new-matches-filter/new-matches-filter.results.tab-model";
import {NewMatchesFilterFixturesTabModel} from "../tabs/new-matches-filter/new-matches-filter.fixtures.tab-model";
import {CompetitorMatchesPageLinkModel} from "../../../../containers/competitor-container/pages/matches-page/models/competitor.matches-page.link-model";

export class NavigationTabsModuleMatchesCompetitorViewModel extends NavigationTabsModuleEntityViewModel {
  terms: NavigationTabsModuleTerms;

  @override get tabs() {
    const fixturesTab: MatchesFilterTabModel = new NewMatchesFilterFixturesTabModel(NAVIGATION_TABS.TAB.INDEX.MATCHES.fixtures, this.terms.WEB_DROPDOWN_FIXTURES, this.entity, this.currentLinkModel, CompetitorMatchesPageLinkModel, this.isWidget);
    const results: MatchesFilterTabModel = new NewMatchesFilterResultsTabModel(NAVIGATION_TABS.TAB.INDEX.MATCHES.results, this.terms.WEB_DROPDOWN_RESULTS, this.entity, this.currentLinkModel, CompetitorMatchesPageLinkModel, this.isWidget);

    const tabs: Array<NavigationTabsModuleTabModel> = [fixturesTab, results];
    const filteredTabs: Array<NavigationTabsModuleTabModel> = tabs.filter(tab => tab.isVisible);

    return filteredTabs;
  }
}
